export const setStorageHash = name => {
  try {
    localStorage.setItem('md5hash', name)
  } catch (e) {
    console.error('set localStorage md5: ' + e)
  }
}
